import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

// Instance level config SUBSCRIBE_THREADS
export const useSubscribeThreadToggle = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(config, "feature_toggles.SUBSCRIBE_THREADS", false);
};
